












































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import axios, { resHandle } from "@/plugins/axios";
import { GetGroupsOfProject } from "@/request/groups";
import { GetUserHospitals } from "@/request/hospitals";
import {
  GetColumnTreeTemplates,
  PostCreateDataTable
} from "@/request/data-filter";
import {
  GetProjectDetail,
  GetTemplatesOfGroup,
  GetTopicsOfTemplate
} from "@/request/projects";
import Pagination from "@/components/paginaiton.vue";
import Header from "../../../components/project-detail-header.vue";
import LeftNav from "../../../components/project-detail-left-nav.vue";
import ProjectSetting from "../../components/project-setting/project-setting.vue";
import SelectMultiSearch from "../../research-list/research-list-folder/select-multi-search.vue";
import TablePreview from "../components/data-table-review/data-table-review.vue";
@Component({
  components: {
    Header,
    LeftNav,
    Pagination,
    ProjectSetting,
    SelectMultiSearch,
    TablePreview
  }
})
export default class DataFilterFolder extends Vue {
  private project: any = {};
  private filters: any = {
    表格名称: "",
    group_id: "",
    hospital_ids: [],
    timeWay: "",
    time: [],
    条件: "全部条件",
    custom: [],
    system: []
  };
  private groups: any[] = [];
  private hospitals: any[] = [];
  private searchedTemplates: any[] = [];
  private treeTemplates: any[] = [];
  // 数据表格预览弹窗
  private ifShowPreview: boolean = false;
  private tableId: any = "";
  /**
   * @description 获取项目详情
   */
  private fetchProject() {
    return new Promise((resolve, reject) => {
      GetProjectDetail(this, this.project.project_id)
        .then((data: any) => {
          this.project = data;
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  }
  /**
   * @description 获得项目下可选的分组
   */
  private fetchGroups() {
    GetGroupsOfProject(this, this.project.project_id).then((data: any) => {
      this.groups = data;
      this.filters.group_id = this.groups[0].group_id;
      this.fetchTemplates();
      this.fetchTreeTemplates();
    });
  }
  /**
   * @description 获得项目下所有的分中心
   */
  private fetchHospitals() {
    GetUserHospitals(this, this.project.project_id).then((data: any) => {
      this.hospitals = data;
      this.hospitals.unshift({ hospital_id: "", 医院名称: "全部" });
    });
  }
  /**
   * @description 获取当前分组下的可选模板列表
   */
  private fetchTemplates() {
    GetTemplatesOfGroup(
      this,
      this.project.project_id,
      this.filters.group_id
    ).then((data: any) => {
      this.searchedTemplates = data;
    });
  }
  private fetchTreeTemplates() {
    GetColumnTreeTemplates(this, this.filters.group_id).then((data: any) => {
      this.treeTemplates = data;
      console.log(this.treeTemplates);
    });
  }
  /**
   * @description 处理切换选择的分组
   */
  private handleGroupChange() {
    this.filters["custom"] = [];
    this.fetchTemplates();
    this.fetchTreeTemplates();
  }
  /**
   * @description 处理选择的分中心变化
   */
  private handleHospitalChange(ev) {
    if (this.filters["hospital_ids"].includes("")) {
      this.filters["hospital_ids"] = [""];
    }
  }
  /**
   * @description 添加研究指标变量
   */
  private addTiaojian() {
    this.filters["custom"].push({ result: {}, selected: {} });
  }
  /**
   * @description 搜索模板下具体的字段
   */
  private searchItems(l) {
    GetTopicsOfTemplate(this, l.template_id).then((data: any) => {
      l.items = data;
      this.$forceUpdate();
    });
  }
  /**
   * @description 删除一个条件
   */
  private deleteTiaojian(index: any) {
    this.filters["custom"].splice(index, 1);
  }
  /**
   * @description 勾选全部列研究指标
   */
  private selectAll() {
    this.treeTemplates.map((first: any) => {
      first.showChild = true;
      first.templates.map((second: any) => {
        second.showChild = true;
        second.choice = true;
        this.handleCheckSecondLevel(true, second);
      });
    });
  }
  /**
   * @description 取消勾选全部
   */
  private clearAll() {
    this.treeTemplates.map((first: any) => {
      first.showChild = true;
      first.templates.map((second: any) => {
        second.showChild = true;
        second.choice = false;
        this.handleCheckSecondLevel(false, second);
      });
    });
  }
  /**
   * @description 控制展示子集
   */
  private triggerShowChild(item) {
    item.showChild = item.showChild ? false : true;
    this.$forceUpdate();
  }
  /**
   * @description 控制切换第二个
   */
  private handleCheckSecondLevel(ev, second) {
    if (ev) {
      second["模板"].map((item: any) => {
        item.choice = true;
      });
      this.$forceUpdate();
    } else {
      second["模板"].map((item: any) => {
        item.choice = false;
      });
      this.$forceUpdate();
    }
  }
  /**
   * @description 控制切换第二个
   */
  private handleCheckThirdLevel(ev, second) {
    if (ev) {
      let allChecked = true;
      second["模板"].map((item: any) => {
        if (item.choice === false) {
          allChecked = false;
        }
      });
      if (allChecked) {
        second.choice = true;
      }
      this.$forceUpdate();
    } else {
      let allNotChecked = true;
      second["模板"].map((item: any) => {
        if (item.choice === true) {
          allNotChecked = false;
        }
      });
      if (allNotChecked) {
        second.choice = false;
      }
      this.$forceUpdate();
    }
  }
  /**
   * @description 验证输入内容
   */
  private validateInput() {
    let valid = true;
    let message = "";
    if (!this.filters["表格名称"]) {
      valid = false;
      message = "请输入表格名称";
    }
    if (this.filters["hospital_ids"].length === 0) {
      valid = false;
      message = "请至少选择一个分中心";
    }
    if (this.filters["timeWay"] === "") {
      valid = false;
      message = "请选择创建时间";
    } else if (this.filters["timeWay"] === "自定义") {
      if (this.filters["time"].length === 0) {
        valid = false;
        message = "请输入自定义时间";
      }
    }
    return new Promise((resolve, reject) => {
      if (valid) {
        resolve();
      } else {
        reject(message);
      }
    });
  }
  /**
   * @description 将filters处理成需要的params参数
   */
  private handleParams() {
    const params: any = {
      project_id: this.project.project_id,
      group_id: this.filters.group_id,
      条件: this.filters["条件"],
      表格名称: this.filters["表格名称"],
      行研究指标: []
    };
    // hospital_ids
    if (this.filters.hospital_ids.includes("")) {
      params.hospital_ids = [];
    } else {
      params.hospital_ids = this.filters.hospital_ids;
    }
    // 创建时间
    if (this.filters["timeWay"] === "自定义") {
      params["开始时间"] = this.filters.time[0];
      params["结束时间"] = this.filters.time[1];
    }
    // 行研究指标
    this.filters.custom.map((zhibiao: any) => {
      params["行研究指标"].push({
        template_id: zhibiao.template_id,
        id: zhibiao.selected.id,
        title: zhibiao.selected.title,
        origin_type: zhibiao.selected.origin_type,
        type: zhibiao.selected.type,
        condition: zhibiao.result.condition,
        value: zhibiao.result.value
      });
    });
    // 列研究指标
    params["列研究指标"] = this.treeTemplates;
    return params;
  }
  /**
   * @description 创建
   */
  private create() {
    this.validateInput()
      .then(() => {
        const params: any = this.handleParams();
        PostCreateDataTable(this, params).then((data: any) => {
          this.$message.success("创建成功");
          this.tableId = data.table_id;
          this.ifShowPreview = true;
        });
      })
      .catch((message: any) => {
        this.$message.error(message);
      });
  }
  /**
   * @description 创建完成预览关闭后返回列表
   */
  private onPreviewClose() {
    this.$router.push(
      "/main/project/data-filter-folder/" + this.project.project_id
    );
  }
  /**
   * @description 初始化
   */
  private beforeMount() {
    this.project.project_id = this.$route.params.project_id;
    this.fetchProject().then(() => {
      this.fetchGroups();
      this.fetchHospitals();
    });
  }
}
